import { makeAutoObservable } from "mobx";
import { onError } from "@/utils/onError";
import { TableSelectStore } from "@/components/TableSelect/TableSelectStore";
import { DataTableStore } from "../../stores/DataTableStore";
import { SearchFilter } from "@/components/filters";
export class SingleWorkShiftStore {
    constructor(workShiftsService, technicianService) {
        this.workShiftsService = workShiftsService;
        this.technicianService = technicianService;
        this.workShift = null;
        this.technicianSelectStore = null;
        this.loading = false;
        makeAutoObservable(this);
    }
    setWorkShift(workShift) {
        this.workShift = workShift;
    }
    setTechnicianSelectStore(technicianSelectStore) {
        this.technicianSelectStore = technicianSelectStore;
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async init(shiftId) {
        this.setLoading(true);
        try {
            // Load both shift and technicians in parallel
            const [shift] = await Promise.all([
                shiftId ? this.workShiftsService.getShiftById(shiftId) : null,
            ]);
            this.setWorkShift(shift);
            // Создаем TableSelectStore для выбора техника
            this.setTechnicianSelectStore(new TableSelectStore(new DataTableStore({
                dataLoader: {
                    loadData: (params) => this.technicianService.getTechniciansWithParams(params),
                },
            }), {
                dataLoader: () => {
                    return this.workShift
                        ? this.technicianService.getTechniciansByIds([
                            this.workShift.idTechnician,
                        ])
                        : Promise.resolve([]);
                },
            }, [
                {
                    id: "technician-search-filter",
                    Cmp: SearchFilter,
                    props: {
                        name: "search",
                        label: "Поиск",
                        placeholder: "Поиск по имени, email...",
                        allowClear: true,
                        showSearchIcon: true,
                        onChange: (value) => this.technicianSelectStore?.filterStore?.updateFilter("search", value),
                    },
                    visible: true,
                    order: 1,
                },
            ]));
            await this.technicianSelectStore?.init();
        }
        catch (error) {
            onError(error, "Error initializing work shift");
        }
        finally {
            this.setLoading(false);
        }
    }
    async saveWorkShift(shiftData) {
        try {
            this.setLoading(true);
            const task = this.workShift
                ? this.workShiftsService.updateShift(this.workShift.id, shiftData)
                : this.workShiftsService.createShift(shiftData);
            this.setWorkShift(await task);
            return this.workShift;
        }
        catch (error) {
            onError(error, "Error saving work shift");
            return null;
        }
        finally {
            this.setLoading(false);
        }
    }
    async deleteWorkShift(shiftId) {
        this.setLoading(true);
        try {
            await this.workShiftsService.deleteShift(shiftId);
            this.setWorkShift(null);
        }
        catch (error) {
            onError(error, "Failed to delete work shift");
        }
        finally {
            this.setLoading(false);
        }
    }
    clearWorkShiftData() {
        this.setWorkShift(null);
        this.setTechnicianSelectStore(null);
        this.setLoading(false);
    }
}
